export class Athlete {
    id: number;
    first_name: string;
    last_name: string;
    teams: string;
    guardians: string;
    gender: string;
    compliant: boolean;
    email: string;
    phone: string;
    removed_status: string;
    removed: boolean;
    image_path: string;
    document_path: string;

    dob: string;
    created_on: string;

    non_compliant_count: number;

    is_removed: boolean;
    is_removed_pending: boolean;

    removed_count: number;
    removed_pending_count: number;
    staff_count: number;
    team_count: number;
    athlete_count: number;
    compliance_count: number;

    compliant_status: boolean;

    admin_name: string;
    club_name: string;

    workflow_tasks: any[];

    pdf_link_parent_auth: string;

    baseline_schedule_link: string;
    show_has_existing_baseline_option: boolean;


    is_compliant: boolean;

    show_schedule_baseline_alert: boolean;

    has_baseline: boolean;


    sportgait_id: string;

    constructor() { }

    formattedName() {
        return this.first_name ?
            this.first_name[0].toUpperCase() + this.first_name.substr(1) + " " + this.last_name[0].toUpperCase() + this.last_name.substr(1) : "";
    }

    initials() {
        return this.first_name[0].toUpperCase() + this.last_name[0].toUpperCase();;
    }

}


// WEBPACK FOOTER //
// ./src/app/_models/athlete.model.ts